import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  terms_and_Conditions_AU_action,
  get_Terms_and_Conditions_details_action,
} from "../../actions/bookingDetails_action/termsAndConditions_action";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import {
  BASE_URL,
  sessionExpireMessage,
  toastError,
  tokenInavlidMessage,
} from "../../utils/constants";
// import Header from '../../common_components/Header';
import { fill_action } from "../../actions/fillList_action";
import "react-datepicker/dist/react-datepicker.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import BookingDetailsAside from "../../common_components/booking_details/bookingDetailsAside";
import Steps from "../../common_components/booking_details/steps";
import Modal from "react-bootstrap/Modal";
import Header from "../../common_components/Header";
import { get_guideline_file_action } from "../../actions/accounts_action/guideline_action";

class TermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      additionalInfo: "",
      acceptTerms: false,
      isOpen: false,
      userID: "",
      orderID: "",
      centerID: "",
      clientID: "", ViewDocument: "",
      isEdit: 0,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.handleadditionalInformation =
      this.handleadditionalInformation.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.navAdditionalServices = this.navAdditionalServices.bind(this);
    this.getTandCDetails = this.getTandCDetails.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    if (JSON.parse(sessionStorage.getItem("Is_modify")) == true) {
      this.setState({
        orderID: JSON.parse(sessionStorage.getItem("OrderID")),
        isEdit: 1,
        centerID: JSON.parse(sessionStorage.getItem("centerID")),
        userID:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        clientID:
          this.props.location.state != null &&
            this.props.location.state.ClientID != null
            ? this.props.location.state.ClientID
            : "",
      });
    } else {
      this.setState({
        centerID:
          this.props.location.state != null &&
            this.props.location.state.CenterID != null
            ? this.props.location.state.CenterID
            : "",
        orderID:
          this.props.location.state != null &&
            this.props.location.state.OrderID != null
            ? this.props.location.state.OrderID
            : "",
        userID:
          sessionStorage.getItem("userId") == "" ||
            sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        clientID:
          this.props.location.state != null &&
            this.props.location.state.ClientID != null
            ? this.props.location.state.ClientID
            : "",
      });
    }
    setTimeout(() => {
      console.log(this.props);
      this.getTandCDetails();
    }, 200);
  }

  handleSubmit(e) {
    e.preventDefault();
    const {
      userID,
      orderID,
      centerID,
      additionalInfo,
      acceptTerms,
      clientID,
      isEdit,
    } = this.state;
    this.setState({ isLoading: true });

    this.props
      .terms_and_Conditions_AU_action(
        userID,
        orderID,
        additionalInfo,
        acceptTerms,
        isEdit
      )
      .then((data) => {
        if (data.error != 1) {
          console.log("done");
          // toastSuccess("Record Added Successfully")
          setTimeout(() => {
            this.props.navigate("/summary", {
              state: {
                CenterID: centerID,
                OrderID: orderID,
                ClientID: clientID,
              },
            });
            this.setState({ isLoading: false });
          }, 300);
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toastError(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  toggleModal() {
    const { acceptTerms, isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
    if (!isOpen) {
      this.props
        .get_guideline_file_action()
        .then((data) => {
          if (data.error != 1) {
            if (data.data != '') {
              const url = BASE_URL.split('/api')
              const file = data.data[0]['GuideLine'].split('/document/guideline/')
              console.log("ducument--------------", url[0] + data.data[0]['GuideLine'])
              this.setState({ isLoading: false, fileName: file[1], GuidelineID: data.data[0]['GuidelineID'], existFilePath: data.data[0]['GuideLine'], ViewDocument: url[0] + data.data[0]['GuideLine'] });
            }
            this.setState({ isLoading: false });
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  getTandCDetails() {
    const { userID, orderID, additionalInfo, acceptTerms } = this.state;
    this.setState({ isLoading: true });
    this.props
      .get_Terms_and_Conditions_details_action(
        userID == "" || userID == null ? null : userID,
        orderID
      )
      .then((data) => {
        console.log(data);
        if (data.error != 1) {
          if (data.data.length != 0) {
            this.setState({
              additionalInfo: data.data[0].AdditionalInformation,
              acceptTerms: data.data[0].Is_Agree,
            });
          }
          setTimeout(() => {
            this.setState({ isLoading: false });
            console.log(this.state.additionalInfo, this.state.acceptTerms);
          }, 300);
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toastError(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  navAdditionalServices() {
    const { orderID, centerID, clientID } = this.state;
    this.props.navigate("/additionalServices", {
      state: { CenterID: centerID, OrderID: orderID, ClientID: clientID },
    });
  }

  onModalClose(value) {
    if (value == true) {
      this.setState({ acceptTerms: true });
      this.toggleModal();
    }
    if (value == false) {
      this.setState({ acceptTerms: false });
      this.toggleModal();
    }
  }

  handleadditionalInformation(e) {
    const { additionalInfo } = this.state;
    let inputString = e.target.value;
    let capitalizedString =
      inputString.charAt(0).toUpperCase() + inputString.slice(1);
    console.log(capitalizedString);
    this.setState({ additionalInfo: capitalizedString });
  }

  render() {
    const { isLoading, isOpen, centerID, additionalInfo, acceptTerms, ViewDocument } =
      this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <main id="main">
          <Header
            data={
              JSON.parse(sessionStorage.getItem("Is_modify")) != true &&
                this.state.orderID != null &&
                this.state.orderID != ""
                ? [2, true]
                : [2]
            }
          />
          <section style={{ marginTop: "115px" }}>
            <div class="container-fluid">
              <div class="row">
                {(centerID != '' && centerID != null) && <BookingDetailsAside data={centerID} />}
                <div class="col-md-9">
                  <div class="md-stepper-horizontal orange">
                    <Steps data={4} />
                  </div>

                  <div
                    class="venue-booking-block"
                    id="venue-availability-form"
                    style={{ marginBottom: "15px !important" }}
                  >
                    <form
                      class="form-horizontal sky-form"
                      role="form"
                      autocomplete="off"
                    >
                      <div class="Terms_and_Conditions">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <span class="floating-label-outside">
                                Additional Information here...
                              </span>
                              <textarea
                                maxLength={1000}
                                style={{ height: "200px" }}
                                value={additionalInfo}
                                id="addInfo"
                                onChange={(e) =>
                                  this.handleadditionalInformation(e)
                                }
                                class="form-control"
                                rows="3"
                              ></textarea>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <fieldset>
                              <legend>Terms and Conditions</legend>

                              <ol style={{ listStyleType: 'none' }}>
                                <li>
                                  1. Clearance certificate to be issued by the
                                  vendor to the client at the time of exit.
                                </li>
                                <li>
                                  2. Event venue to be booked 20 days before the
                                  event date.
                                </li>
                                <li>
                                  3. Additional working hours and overnight setup
                                  charges/storage charges will be applicable as per availability.
                                </li>
                                <li >
                                  4.1 Booking forms and its terms form terms agreement document between client and ITME Society for venue hire.
                                </li>
                                <li >
                                  4.2 By submitting this form, the client agrees to the terms and conditions and confirms this contact agreement.
                                </li>
                                <li>
                                  5. Primary Contact/Authorised person of the company will be liable for the validation of the contract.
                                </li>
                              </ol>

                              <div class="bg TermAndConditionCheckbox">
                                <div class="chiller_cb">
                                  <input
                                    checked={acceptTerms}
                                    type="checkbox"
                                  />
                                  <label
                                    onClick={this.toggleModal}
                                    // onClick={() => this.setState({ acceptTerms: !acceptTerms })}
                                    for="myCheckbox2"
                                  >
                                    I have read the{" "}
                                    <a style={{ color: "#35b3e6" }}>
                                      rules and regulations
                                    </a>{" "}
                                    for ITME CENTER and agree to abide by them,
                                    also above given information are correct and
                                    best of my knowledge.
                                  </label>
                                  <span></span>
                                </div>
                              </div>
                              <div class="row">
                                <div className="col-md-12">
                                  <p className="ml-4">
                                    Please note that to proceed further for
                                    booking completion you have to click on 'I
                                    agree' on Rules and Regulations page.
                                  </p>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>

                        {/* <div class="row">
                      <div class="col-md-12">
                        <div class="order_summary_div">
                          <div class="">
                            <div class="">
                              <div class="">
                                <div class="order_summary_and_address">
                                  <h6 class="Order_Summary_heading">Order Summary</h6>
                                  <h5 class="cart_title"></h5>
                                  <p class="card_location"><i class="fa fa-map-marker"></i> Nariman Point, Mumbai.</p>
                                </div>
                                <div class="card_items">
                                  <div class="time_slot">
                                    <span><strong>Booking Date</strong></span><span><strong>Booking Slot</strong></span>
                                  </div>
                                  <div class="time_slot">
                                    <span>Jul 10, 2023</span><span>09:00 AM – 01:00 PM</span>
                                  </div>
                                  <div class="time_slot">
                                    <span>Jul 10, 2023</span><span>09:00 AM – 01:00 PM</span>
                                  </div>
                                  <div class="time_slot">
                                    <span>Jul 10, 2023</span><span>09:00 AM – 01:00 PM</span>
                                  </div>
                                  <div class="time_slot">
                                    <span>Jul 10, 2023</span><span>09:00 AM – 01:00 PM</span>
                                  </div>
                                  <div class="time_slot Total_timeslot_count">
                                    <span>Total</span><span>₹ 1,00,00</span>
                                  </div>
                                </div>
                                <div class="total_count_div">
                                  <h6>Additional Services</h6>
                                  <div class="">
                                    <div class="time_slot">
                                      <span>Broadband</span><span>₹ 1,000</span>
                                    </div>
                                    <div class="time_slot">
                                      <span>Catering (40)</span><span>₹ 24,000</span>
                                    </div>
                                    <div class="time_slot Total_timeslot_count">
                                      <span>Total</span><span>₹ 25,000</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="total_count_div" style={{background: "#e7e7e7"}}>
                                  <ul class="order-details">
                                      <li class="change-case"><div class="pric-lbl">Amount INR</div> <div class="cart-number qtyty"> <span class="cost">₹ 1,25,000</span></div></li>
                                      <li class="change-case"><div class="pric-lbl">GST 18%</div> <div class="cart-number qtyty"> <span class="cost">₹ 22,500</span></div></li>
                                      <li><div class="pric-lbl"><strong>Total</strong></div> <div class="cart-number qtyty"> <span class="cost"><strong>₹ 1,47,500</strong></span></div></li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                        <div class="row">
                          <div class="col-md-12 my_buttons">
                            <button
                              onClick={this.navAdditionalServices}
                              class="btn btn-secondary custom_btn previous_to_company_info_btn"
                            >
                              {" "}
                              <a>
                                Step 3{" "}
                                <span className="hide_on_mobile_css">
                                  : Additional Services
                                </span>
                              </a>
                            </button>
                            <button
                              onClick={(e) => this.handleSubmit(e)}
                              disabled={!acceptTerms}
                              class="btn btn-success custom_btn"
                            >
                              <a>
                                Step 5{" "}
                                <span className="hide_on_mobile_css">
                                  : Order Summary
                                </span>
                              </a>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div >
          </section >
        </main >
        <Modal
          // size="xl"
          dialogClassName="modal-70w"
          show={isOpen}
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Body className="p-0">
            <iframe
              className="mb-n2"
              id="myIframe"
              src={ViewDocument}
              width="100%"
              height="650px"
              title="Bing"
            ></iframe>
          </Modal.Body>
          <Modal.Footer className="p-0">
            <button
              // style={{ scale: "0.85" }}
              onClick={() => this.onModalClose(false)}
              class="btn btn-secondary ml-2"
            >
              Close
            </button>
            <button
              style={{ float: "right", }}
              onClick={() => this.onModalClose(true)}
              class="btn btn-primary mr-2"
            >
              I Agree
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    terms_and_Conditions_AU_action,
    get_Terms_and_Conditions_details_action,
    fill_action, get_guideline_file_action
  })(TermsAndConditions)
);
